import { render, staticRenderFns } from "./IndexPosterList.vue?vue&type=template&id=8dd73c9c&scoped=true&"
import script from "./IndexPosterList.vue?vue&type=script&lang=js&"
export * from "./IndexPosterList.vue?vue&type=script&lang=js&"
import style0 from "./IndexPosterList.vue?vue&type=style&index=0&id=8dd73c9c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dd73c9c",
  null
  
)

export default component.exports